export const environment = {
    production: false,
    apiHost: "https://admin.dev.upnn.co.in",
    apiPort: 3000,
    loginWithPassword: true
  };

